module.exports = __webpack_public_path__ + "static/img/heat-treatmentD2.c5d2d8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/heat-treatmentD2.png
// module id = YVM+
// module chunks = 1